// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"testCheckBox_wrapper_nd-aN","span":"testCheckBox_span_2UXcs","input":"testCheckBox_input_2AUf5"};